module.exports = __webpack_public_path__ + "img/fb.5a33fd3a.png";